import { useEffect, useState } from "react"

import { useLazyGetInstalledDevicesWidgetQuery } from "store/api/adminApi"
import { useLazyGetInstalledDevicesQuery } from "store/api/widgetsApi"

import { getDateRangeFromOption } from "utils/dateUtils"
import { HalfDoughnutSummaryWidget } from "components/widgets/HalfDoughnutSummaryWidget"
import { allDateSelectOptions } from "pages/vendor/Dashboard/constants"

const CHART_COLORS = {
  online: "#22C55E",
  offline: "#E2E8F0",
} as const

interface Props {
  isVendor?: boolean
}

export const WidgetInstaledDevices = ({ isVendor = false }: Props) => {
  const [selectedDateRange, setSelectedDateRange] = useState(() => getDateRangeFromOption("all"))
  const [triggerVendorInstalledDevices, { isFetching: isVendorFetching, data: vendorData }] =
    useLazyGetInstalledDevicesWidgetQuery()
  const [triggerContractorInstalledDevices, { isFetching: isContractorFetching, data: contractorData }] =
    useLazyGetInstalledDevicesQuery()
  const [widgetData, setWidgetData] = useState({ online: 0, offline: 0 })

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (isVendor) {
          await triggerVendorInstalledDevices()
        } else {
          await triggerContractorInstalledDevices({
            date_start: selectedDateRange[0],
            date_end: selectedDateRange[1],
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [isVendor, selectedDateRange, triggerVendorInstalledDevices, triggerContractorInstalledDevices])

  useEffect(() => {
    const d = isVendor ? vendorData?.data : contractorData?.data
    if (!d) return

    setWidgetData({
      online: d.online ?? 0,
      offline: d.offline ?? 0,
    })
  }, [isVendor, vendorData, contractorData])

  const items = [
    { label: "Online", color: CHART_COLORS.online, value: widgetData.online },
    { label: "Offline", color: CHART_COLORS.offline, value: widgetData.offline },
  ]

  return (
    <HalfDoughnutSummaryWidget
      title="Installed Thermostats"
      mainLabel="Thermostats"
      items={items}
      chartOptions={{ cutout: "65%" }}
      showPercentage
      isFetching={isVendor ? isVendorFetching : isContractorFetching}
      dateSelectOptions={!isVendor ? allDateSelectOptions : undefined}
      onSelectDateRange={!isVendor ? setSelectedDateRange : undefined}
      defaultSelectedDateOption={!isVendor ? allDateSelectOptions[0] : undefined}
    />
  )
}
